/**
 * Vendor Service Hooks
 * React hooks for accessing vendor management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all vendor-related services
 * @returns VendorServices object containing all vendor service instances
 */
export function useVendorsServices() {
    const { services } = useCCMS();
    if (!services?.vendors) {
        throw new Error('Vendor services not available. Ensure CCMSProvider is configured with vendor services.');
    }
    return services.vendors;
}
/**
 * Hook to access VendorService
 */
export function useVendorService() {
    return useVendorsServices().vendor;
}
/**
 * Hook to access VendorTypeService
 */
export function useVendorTypeService() {
    return useVendorsServices().vendorType;
}
/**
 * Hook to access VendorStatusService
 */
export function useVendorStatusService() {
    return useVendorsServices().vendorStatus;
}
/**
 * Hook to access VendorContactService
 */
export function useVendorContactService() {
    return useVendorsServices().vendorContact;
}
/**
 * Hook to access VendorLocationService
 */
export function useVendorLocationService() {
    return useVendorsServices().vendorLocation;
}
/**
 * Hook to access VendorDocumentService
 */
export function useVendorDocumentService() {
    return useVendorsServices().vendorDocument;
}
/**
 * Hook to access VendorDocumentTypeService
 */
export function useVendorDocumentTypeService() {
    return useVendorsServices().vendorDocumentType;
}
/**
 * Hook to access VendorTermService
 */
export function useVendorTermService() {
    return useVendorsServices().vendorTerm;
}
/**
 * Hook to access VendorTermPeriodService
 */
export function useVendorTermPeriodService() {
    return useVendorsServices().vendorTermPeriod;
}
/**
 * Hook to access VendorPaymentService
 */
export function useVendorPaymentService() {
    return useVendorsServices().vendorPayment;
}
/**
 * Hook to access VendorDonationService
 */
export function useVendorDonationService() {
    return useVendorsServices().vendorDonation;
}
/**
 * Hook to access VendorStatusHistoryService
 */
export function useVendorStatusHistoryService() {
    return useVendorsServices().vendorStatusHistory;
}
/**
 * Hook to access VendorLogService
 */
export function useVendorLogService() {
    return useVendorsServices().vendorLog;
}
/**
 * Hook to access UserVendorService
 */
export function useUserVendorService() {
    return useVendorsServices().userVendor;
}
/**
 * Hook to access VendorRegistrationService
 */
export function useVendorRegistrationService() {
    return useVendorsServices().vendorRegistration;
}
/**
 * Hook to access VendorSocialMediaService
 */
export function useVendorSocialMediaService() {
    return useVendorsServices().vendorSocialMedia;
}
/**
 * Hook to access VendorShopService
 */
export function useVendorShopService() {
    return useVendorsServices().vendorShop;
}
/**
 * Hook to access VendorLedgerService
 */
export function useVendorLedgerService() {
    return useVendorsServices().vendorLedger;
}
/**
 * Hook to access VendorPayoutService
 */
export function useVendorPayoutService() {
    return useVendorsServices().vendorPayout;
}
//# sourceMappingURL=useVendorsServices.js.map